import React from "react";

import {MscAdresse, MscVersandart, MscWizard, MscWizardAction} from "../interfaces";

export const WizardInitialState: MscWizard = {
    loading: false,
    suchewoerter: '',
    vorschlaegeAdressen: null,
    ausgewaehlteAdresse: null,
    abonierenState: undefined,
    kontakt: {
        nummer: '',
        email: '',
        versandart: MscVersandart.MOBIL,
        valide: false
    },
    step: 'adresse'
};


const validateKontakt = (prevState: MscWizard): MscWizard => ({
    ...prevState,
    kontakt: {
        ...prevState.kontakt,
        valide: /^\+(?:[0-9] ?){6,14}[0-9]$/.test(prevState.kontakt.nummer)
    }
});

const Wizard: React.Reducer<MscWizard, MscWizardAction> = (prevState, action) => {
    switch (action.type)  {
        case 'SET_SUCHWOERTER': {
            const vorschlaegeAdressen = action.value.trim().length ? prevState.vorschlaegeAdressen : null;
            return {
                ...prevState,
                loading: true,
                suchewoerter: action.value,
                vorschlaegeAdressen
            };
        }
        // { type: 'SET_ADRESSEN_AUSWAHL', value: LimitedResult<MscAdresse>}
        case 'SET_ADRESSEN_AUSWAHL': {

            return {
                ...prevState,
                loading: false,
                vorschlaegeAdressen: action.value
            };
        }
        // { type: 'SET_ADRESSE_AUSGEWAEHLT', value: MscAdresse}
        case 'SET_ADRESSE_AUSGEWAEHLT': {
            return {
                ...prevState,
                ausgewaehlteAdresse: action.value,
                step: "kontakt"
            };
        }
        // { type: 'SET_KONTAKT_VERSANDART', value: MscVersandart}
        case 'SET_KONTAKT_VERSANDART': {
            return prevState;
        }
        // { type: 'SET_KONTAKT_EMAIL', value: string}
        case 'SET_KONTAKT_EMAIL': {
            return prevState;
        }
        case 'SET_KONTAKT_NUMMER': {
            return validateKontakt({
                ...prevState,
                kontakt: {
                    ...prevState.kontakt,
                    nummer: action.value.trim()
                }
            });
        }
        case 'SET_STEP': {
            const abonierenState = ['adresse', 'kontakt'].indexOf(action.value) > -1 ? undefined : prevState.abonierenState;
            return {
                ...prevState,
                abonierenState,
                step: action.value
            };
        }
        case 'ABONIERE': {
            return {
                ...prevState,
                abonierenState: 'aboniere'
            };
        }
        case 'ABONIEREN_ERFOLGREICH': {
            return {
                ...prevState,
                abonierenState: 'abonieren_erfolgreich',
                step: "quittung"
            };
        }
        case 'ABONIEREN_FEHLGESCHLAGEN': {
            return {
                ...prevState,
                abonierenState: 'abonieren_fehlgeschlagen'
            };
        }
        case 'RESET': {
            return {
                ...WizardInitialState
            }
        }
    }
};

export default Wizard;